$(window).on('load resize scroll', function() {
  // Animation
  $('.js-animate').each(function() {
    var offset = $(this).data('offset') ? $(this).data('offset') : 0;
    var repeat = $(this).data('repeat') ? $(this).data('repeat') : false;
    var target = $(this).data('target') ? $('#' + $(this).data('target')) : $(this);

    if ($(window).scrollTop() + $(window).height() + offset > $(this).offset().top) {
      target.addClass('is-active');
    }else{
      if(repeat) {
        target.removeClass('is-active');
      }
    }
  });
});
